import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

export default {
  isMaintenanceModeEnabled() {
    return axios.get(`${process.env.CONFIG_V1}`)
      .then(data => {
        let maintenanceCfg = _.get(data, 'data.maintenanceMode.sfmExpressPay');
        // Blanket maintenance mode is indefinite
        if (_.get(maintenanceCfg, 'maintenanceMode')) {
          return true;
        }
        // Scheduled maintenance mode check (finite time frame)
        // Times are stored in UTC for consistency regardless of TZ
        if (_.get(maintenanceCfg, 'maintenanceModeStart') && _.get(maintenanceCfg, 'maintenanceModeEnd')) {
          let start = moment(_.get(maintenanceCfg, 'maintenanceModeStart'));
          let end = moment(_.get(maintenanceCfg, 'maintenanceModeEnd'));
          let current = moment();

          if (current.isSameOrAfter(start) && current.isSameOrBefore(end)) {
            return true;
          }
        }

        return false;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/ConfigService.js